import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./HomePage.module.scss";

// Ilustrační obrázky – upravte si cesty dle potřeby
import diceImg from "../../assets/Dice.png";
import randomImg from "../../assets/List.png";
import numberImg from "../../assets/Number.png";
import teamsImg from "../../assets/Team.png";
import wheelImg from "../../assets/Wheel.png";

function HomePage() {
  const activities = [
    { title: "Hod kostkou", route: "/dice", img: diceImg },
    { title: "Generátor čísel", route: "/number", img: numberImg },
    { title: "Náhodný výběr", route: "/random", img: randomImg },
    { title: "Kolo štěstí", route: "/wheel", img: wheelImg },
    { title: "Rozdělení do týmů", route: "/teams", img: teamsImg },
  ];

  return (
    <div className={styles.home}>
      <div className={styles.hero}>
        <h1>Vítejte v RandGen!</h1>
        <p className="homep">
          Vyberte si aktivitu, kterou chcete spustit. Každá hra má svůj unikátní
          design a historii.
        </p>
      </div>
      <div className={styles.cards}>
        {activities.map((act, idx) => (
          <NavLink key={idx} to={act.route} className={styles.card}>
            <img src={act.img} alt={act.title} />
            <h2>{act.title}</h2>
          </NavLink>
        ))}
      </div>
    </div>
  );
}

export default HomePage;
